import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Warning = () => {
  return (
    <Box
      background="champagne400"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Text.Normal>
        {i18n.t('contract_versions.header.pause_resume.pause_modal.bottom_message')}
      </Text.Normal>
    </Box>
  )
}

export default Warning
